import { TableSelect } from "./types";

export const initialTableSelectState: TableSelect = {
  selectedRecordIds: [],
  excludeRecordIds: [],
  isAllSelected: false,
};
